const patchSection = (state, action) => {
  const sections = [...state.sections];
  const sectionIndex = sections.indexOf(action.payload.section);
  if (sectionIndex === -1) {
    return state;
  }

  const section = {
    ...action.payload.section,
    ...action.payload.patch,
  };
  sections[sectionIndex] = section;

  return {
    ...state,
    sections,
    currentSection:
      action.payload.section === state.currentSection
        ? section
        : state.currentSection,
  };
};

export default patchSection;
